import * as Yup from 'yup'

import { CreateBespokeRatingValues } from './models'

export const issuerComplianceRuleValidationSchema: Yup.SchemaOf<CreateBespokeRatingValues> = Yup.object().shape({
  bankingGroupId: Yup.number().required(),
  startDate: Yup.date(),
  maxLimitShort: Yup.number().required(),
  maxLimitLong: Yup.number().required(),
  maxMoneyLimitShort: Yup.number().required(),
  maxMoneyLimitLong: Yup.number().required(),
})
